import React from 'react';
import ReactDOM from 'react-dom';
import io from 'socket.io-client';
import $ from './jquery';
import axios from 'axios';
import { configure } from 'axios-hooks';
import 'bootstrap';

import 'font-awesome/css/font-awesome.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'sweetalert/dist/sweetalert.css';
import '../css/theme/app.css';
import '../css/theme/theme-b.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/timegrid/main.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '@jh3y/whirl/dist/whirl.css';

import '../css/styles.scss';

import { API_URL, CHAT_URL } from './config/constants';
import User from './models/provider';
import Main from './Main';

if (process.env.NODE_ENV === 'production') {
	if (location.protocol == 'http:')
		location.href = location.href.replace(/^http:/, 'https:');
}

configure(axios);
axios.defaults.baseURL = API_URL;

const app = function () {
	var app = {
		start: () => {
			ReactDOM.render(<Main app={app} />, document.getElementById('app'));
		},
	};

	app.user = new User({ connected: false });

	app.socket = io.connect(CHAT_URL, {
		transports: ['websocket'],
	});

	const logoutOn401 = () => {
		window.location = '#/logout';
	};

	// Add a response interceptor
	axios.interceptors.response.use(
		function (response) {
			// Any status code that lie within the range of 2xx cause this function to trigger
			// Do something with response data
			return response;
		},
		function (error) {
			// Any status codes that falls outside the range of 2xx cause this function to trigger
			// Do something with response error
			if (error.response && 401 === error.response.status) {
				// console.log('LOGOUT from axios')
				logoutOn401();
			} else {
				return Promise.reject(error);
			}
		}
	);

	$.ajaxSetup({
		statusCode: {
			401: logoutOn401,
		},
	});

	return app;
};

const instance = app();

instance.user.checkAuth(function () {
	instance.start();
});
